module.exports = __webpack_public_path__ + "assets/7ddbb248ac88179ef2f44c65dfb062f8.mp3";